import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';


@Component({
  selector: 'app-product',
  imports: [
    RouterLink,
    MatCardModule, MatGridListModule, MatIconModule,
    MatChipsModule, MatButtonModule, MatTooltipModule, TranslateModule
  ],
  templateUrl: './product.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './product.component.css'
})
export class ProductComponent {
  runtimes = [
    { name: 'Node.js', icon: 'nodejs' },
    { name: 'Deno', icon: 'deno' },
    { name: 'Python', icon: 'python' },
    { name: 'Go', icon: 'go' },
    { name: 'Rust', icon: 'rust' },
    { name: 'Ruby', icon: 'ruby' },
    { name: 'Elixir', icon: 'elixir' },
    { name: 'PHP', icon: 'php' },
    { name: 'JVM (Java/Kotlin)', icon: 'jvm' },
    { name: '.NET', icon: 'dotnet' },
    { name: 'C++', icon: 'cpp' },
  ];
}
